import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from '@/modules/common/components/Select';
import TextField from '@/modules/common/components/TextField';
import { withRouter } from '@/hocs/router';

const Form = (props) => {
    const offerName = props.match.params.offerName;

    const getStatusOptions = () => {
        const statuses = props.statuses.filter((status) => status.offer.offer_name === offerName);
        return statuses.map((status) => ({title: status.status, value: status.id.toString()}));
    };

    const handleChange = (prop) => (event) => {
        props.setValues({...props.values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        props.setErrors({...props.errors, [prop]: ''});
    };

    return (
        <>
            <Select label="Начальный статус" options={getStatusOptions()}
                    value={props.values.statusFrom}
                    onChange={handleChange('statusFrom')}
                    error={props.errors.statusFrom.length > 0}
                    helperText={props.errors.statusFrom}
                    onFocus={handleFocus('statusFrom')}
                    autoFocus={true}
            />
            <Select label="Конечный статус" options={getStatusOptions()}
                    value={props.values.statusTo}
                    onChange={handleChange('statusTo')}
                    error={props.errors.statusTo.length > 0}
                    helperText={props.errors.statusTo}
                    onFocus={handleFocus('statusTo')}
            />
            <TextField label="Интервал (дн.)" type="number"
                       value={props.values.interval}
                       onChange={handleChange('interval')}
                       error={props.errors.interval.length > 0}
                       helperText={props.errors.interval}
                       onFocus={handleFocus('interval')}
                       inputProps={{min: 1}}
            />
        </>
    );
};

Form.propTypes = {
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    setErrors: PropTypes.func.isRequired,
};

let Component = withRouter(Form);

export default connect(
    (state) => ({
        statuses: state.statuses,
    })
)(Component);
